import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import MaintenancePage from './components/shared/MaintenancePage';
import { validateConfig } from './utils/config';

// Build-time switch: when set, serve only the maintenance notice (the backend
// is suspended, so the app itself cannot work).
const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

// Validate configuration on app startup
if (!maintenanceMode) {
  validateConfig();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {maintenanceMode ? <MaintenancePage /> : <App />}
  </React.StrictMode>
);
